<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Códigos'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Form -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataCode.companyId" :b-invalid="false" :b-success="false">
                        <label for="title">Id da empresa</label>
                        <input v-model="dataCode.companyId" @blur="$v.dataCode.companyId.$touch()" type="text"
                               class="form-control" id="companyId" name="companyId">
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataCode.title" :b-invalid="false" :b-success="false">
                        <label for="title">Título</label>
                        <input v-model="dataCode.title" @blur="$v.dataCode.title.$touch()" type="text"
                               class="form-control" id="title" name="title">
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.price" :b-invalid="false" :b-success="false">
                        <label for="value">Valor</label>
                        <input v-model.lazy="price" v-money="money" @blur="$v.price.$touch()" type="text"
                               class="form-control" id="value" name="value"/>
                      </valid-field>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <!--                  <div class="col-xs-12 col-sm-6 col-md-4">-->
                  <!--                    <div class="form-group">-->
                  <!--                      <label>Tipo Pagamento</label>-->
                  <!--                      <select v-model="dataCode.paymentMethod">-->
                  <!--                        <option value="">Selecione</option>-->
                  <!--                        <option value="1">Boleto</option>-->
                  <!--                        <option value="2">Cartão Crédito</option>-->
                  <!--                        <option value="3">Dinheiro</option>-->
                  <!--                        <option value="4">Transferência Bancaria</option>-->
                  <!--                        <option value="10">Todos</option>-->
                  <!--                      </select>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataCode.totalEmployee" :b-invalid="false" :b-success="false">
                        <label for="value">Total maximo funcionário</label>
                        <input v-model="dataCode.totalEmployee" @blur="$v.dataCode.totalEmployee.$touch()" type="text"
                               class="form-control" id="totalEmployee" name="totalEmployee">
                      </valid-field>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <valid-field :v="$v.dataCode.description" :b-invalid="false" :b-success="false">
                        <label for="description">Descrição</label>
                        <textarea v-model="dataCode.description" @blur="$v.dataCode.description.$touch()"
                                  class="form-control" id="description" name="description"></textarea>
                      </valid-field>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="registerCode()">
                    <span v-if="!loadingRequest">Cadastrar</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import validField from "../../components/default/validField.vue";
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  VMoney
} from 'v-money'
import {
  CREATE_CODE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

import {
  required
} from 'vuelidate/lib/validators';

export default {
  name: "code-subscription",
  directives: {
    money: VMoney
  },
  components: {
    topMenu,
    pageHeader,
    validField,
    fullLoading
  },
  data() {
    return {
      loading: false,
      loadingRequest: false,
      dataCode: {
        companyId: "",
        totalEmployee: "",
        title: "",
        description: "Tenha na sua empresa o melhor controle de ponto eletrônico online",
        value: "",
        paymentMethod: ""
      },
      price: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    registerCode() {
      if (this.dataCode.companyId && this.dataCode.title && this.dataCode.description && this.price && this.dataCode.totalEmployee) {
        this.dataCode.value = this.price.replace("R$ ", "");
        this.loadingRequest = true;

        UTIL_SERVICE.console("DATA SEND:", this.dataCode);
        REQUEST_SERVICE.post(CREATE_CODE, this.dataCode).then((response) => {
          UTIL_SERVICE.console("RESULT CREATE_CODE:", response.data);

          this.loadingRequest = false;
          this.failRequest = false;
          swal("Aviso", response.data, "success");

          // Redirect user.
          this.$router.push({
            path: '/codigos-gerado'
          });
        }).catch((reason) => {
          this.loadingRequest = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      } else {
        swal("Aviso", "Preencha o formulário completo antes de continuar.", "error");
      }
    }
  },
  validations: {
    price: {
      required
    },
    dataCode: {
      companyId: {
        required
      },
      title: {
        required,
      },
      description: {
        required,
      },
      totalEmployee: {
        required
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/registerCodeSubscription/registerCodeSubscription.vue